/** 开户/转入共用：手写签名 canvas 导出 PNG（从 open-progress Signature 抽取） */

export const dataURLtoFile = (dataUrl: string, filename: string): File => {
  const data = dataUrl.split(',')[1] || '';
  const binary = atob(data);
  const u8 = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i++) u8[i] = binary.charCodeAt(i);
  const blob = new Blob([u8], { type: 'image/png' });
  const name = filename.endsWith('.png') ? filename : `${filename}.png`;
  return new File([blob], name, { type: 'image/png' });
};

export const finalSignatureBase64 = (canvas: HTMLCanvasElement) => {
  const OUT_W = 400;
  const OUT_H = 100;
  const dpr = Math.min(window.devicePixelRatio || 1, 2);

  const w = canvas.width;
  const h = canvas.height;
  const px = canvas.getContext('2d')!.getImageData(0, 0, w, h).data;
  let x0 = w;
  let y0 = h;
  let x1 = 0;
  let y1 = 0;
  for (let y = 0; y < h; y++) {
    for (let x = 0; x < w; x++) {
      const i = (y * w + x) * 4;
      if (px[i] < 245 || px[i + 1] < 245 || px[i + 2] < 245) {
        if (x < x0) x0 = x;
        if (x > x1) x1 = x;
        if (y < y0) y0 = y;
        if (y > y1) y1 = y;
      }
    }
  }
  if (x0 > x1 || y0 > y1) return '';

  const pad = Math.round(12 * dpr);
  x0 = Math.max(0, x0 - pad);
  y0 = Math.max(0, y0 - pad);
  x1 = Math.min(w - 1, x1 + pad);
  y1 = Math.min(h - 1, y1 + pad);
  const srcW = x1 - x0 + 1;
  const srcH = y1 - y0 + 1;

  const fitScale = Math.min(OUT_W / (srcH / dpr), OUT_H / (srcW / dpr));
  const fitW = Math.round((srcH / dpr) * fitScale);
  const fitH = Math.round((srcW / dpr) * fitScale);
  const fitX = Math.round((OUT_W - fitW) / 2);
  const fitY = Math.round((OUT_H - fitH) / 2);

  const tempCanvas = document.createElement('canvas');
  tempCanvas.width = OUT_W;
  tempCanvas.height = OUT_H;
  const ctx = tempCanvas.getContext('2d')!;
  ctx.fillStyle = '#fff';
  ctx.fillRect(0, 0, OUT_W, OUT_H);
  ctx.imageSmoothingEnabled = true;
  ctx.imageSmoothingQuality = 'high';

  ctx.save();
  ctx.translate(fitX, fitY + fitH);
  ctx.rotate(-Math.PI / 2);
  ctx.drawImage(canvas, x0, y0, srcW, srcH, 0, 0, fitH, fitW);
  ctx.restore();

  return tempCanvas.toDataURL('image/png', 0.9);
};

export const SIGNATURE_HEADER_OFFSET = 104;
export const SIGNATURE_MOBILE_HEADER = 54;
export const SIGNATURE_EDGE_INSET = 12;

export const getSignatureFallbackSize = () => {
  const shell = typeof document !== 'undefined' ? document.getElementById('h5-shell') : null;
  if (shell?.classList.contains('h5-shell--pc')) {
    return {
      width: shell.clientWidth || 430,
      height: Math.max(0, shell.clientHeight - SIGNATURE_MOBILE_HEADER),
    };
  }
  return {
    width: typeof window !== 'undefined' ? window.innerWidth : 390,
    height: typeof window !== 'undefined' ? Math.max(0, window.innerHeight - SIGNATURE_HEADER_OFFSET) : 500,
  };
};
